
/* styles */
require("!!../../../extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../vue-loader/lib/style-rewriter?id=data-v-57141405&scoped=true!../../../vue-loader/lib/selector?type=styles&index=0!./PopoverRow.vue")

var Component = require("!../../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../vue-loader/lib/selector?type=script&index=0!./PopoverRow.vue"),
  /* template */
  require("!!../../../vue-loader/lib/template-compiler?id=data-v-57141405!../../../vue-loader/lib/selector?type=template&index=0!./PopoverRow.vue"),
  /* scopeId */
  "data-v-57141405",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/v-calendar/src/components/PopoverRow.vue
// module id = 1389
// module chunks = 94